<template>
    <b-list-group-item class="tree-node" :class="'depth' + options.depth">
        <template v-if="selectable">
            <b-form-checkbox @change="checkboxChanged" :checked="isChecked" ref="checkbox" :indeterminate="indeterminate">
                {{ itemName }}
                <span class="count" v-if="itemCount">({{ itemCount }})</span>
            </b-form-checkbox>
        </template>
        <template v-else>
            <a href="#" @click.prevent="nodeclicked(node)" :title="itemName">
                {{ itemName }}
                <span class="count" v-if="itemCount">({{ itemCount }})</span>
            </a>
        </template>
        <button type="button" class="btn btn-tree-node" :class="{ active: isOpen }" @click.prevent="isOpen = !isOpen" title="Open" v-if="isFolder">
            <i class="fal fa-fw fa-chevron-down"></i>
            <span class="sr-only">Open {{ itemName }}</span>
        </button>
        <div :id="'node' + node.name" class="collapse" :class="{ show: isOpen }" v-if="isFolder">
            <b-list-group>
                <tree-item
                    v-for="(child, key) in children"
                    :key="key"
                    :node="child"
                    :name="name"
                    :selectable="selectable"
                    :options="options"
                    :parent="nodeId"
                    v-model="store"
                    @input="emitChange"
                    @nodeclicked="nodeclicked"
                ></tree-item>
            </b-list-group>
        </div>
    </b-list-group-item>
</template>

<script>
import _ from 'lodash';
import Tree from './Tree';

export default {
    name: 'tree-item',
    components: { Tree },
    props: {
        node: {
            type: Object,
            required: true,
        },
        name: {
            required: true,
        },
        value: {
            required: false,
        },
        selectable: {
            type: Boolean,
            default: true,
        },
        parent: {
            default: null,
        },
        options: {
            type: Object,
            default: () => {
                return {};
            },
        },
        intVal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            store: [],
            isOpen: false,
        };
    },
    created() {
        this.options.depth = this.options.depth + 1;
    },
    computed: {
        indeterminate() {
            return !this.isChecked && this.childrenChecked;
        },
        isChecked() {
            return _.includes(this.store, this.nodeId);
        },
        childrenChecked() {
            return _.intersection(this.node.childIds, this.store).length > 0;
        },
        itemCount() {
            return _.get(this.node, this.options.keys.count);
        },
        itemLink() {
            return _.get(this.node, this.options.keys.path, '#');
        },
        itemName() {
            return _.get(this.node, this.options.keys.name);
        },
        nodeId() {
            return _.get(this.node, this.options.keys.id);
        },
        children() {
            return _.get(this.node, this.options.keys.children);
        },
        isFolder: function () {
            return _.has(this.node, this.options.keys.children) && _.get(this.node, this.options.keys.children).length > 0;
        },
    },
    methods: {
        checkboxChanged(checked) {
            let store = new Set(this.store);
            let parents = new Set(this.node.parentIds);
            let children = new Set(this.node.childIds);

            if (checked) {
                // Check this node and all children
                store.add(this.nodeId);
                children.forEach((child) => {
                    store.add(child);
                });
            } else {
                // Uncheck this node, all parents, and all children
                store.delete(this.nodeId);
                parents.forEach((parent) => {
                    store.delete(parent);
                });
                children.forEach((child) => {
                    store.delete(child);
                });
            }

            this.emitChange(Array.from(store));
        },
        nodeclicked(node) {
            this.$emit('nodeclicked', node);
        },
        emitChange(newVal) {
            this.$emit('input', newVal);
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (Array.isArray(newVal)) {
                    this.store = newVal;
                } else if (newVal != null) {
                    this.store = [newVal];
                } else {
                    this.store = [];
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-control {
    display: inline;
}

.btn-tree-node > i,
.btn-tree-node > .svg-inline--fa {
    transition: all 0.3s;
}

.btn-tree-node.active > i,
.btn-tree-node.active > .svg-inline--fa {
    transform: rotate(180deg);
}
</style>
